import { Type } from 'class-transformer';
import { IsDefined, IsEnum, IsNotEmpty, IsOptional, ValidateNested } from 'class-validator';
import { BaseDto } from '../../@base/base.dto';
import { ContactInfosDto } from '../../administrative';
import { IsMongoIdObject } from '../../decorators/is-mongo-object-id.decorator';
import { UserId, UserRegistrationId } from '../../types';
import { UserRegistrationConfirmationDto } from './user-registration-confirmation.dto';
import { UserRegistrationIdentityDto } from './user-registration-identity.dto';
import { UserRegistrationStep } from './user-registration-step.enum';

export class UserRegistrationDto extends BaseDto<UserRegistrationId> {
  @ValidateNested()
  @Type(() => UserRegistrationIdentityDto)
  identity!: UserRegistrationIdentityDto;

  @ValidateNested()
  @Type(() => ContactInfosDto)
  @IsDefined()
  contactInfos!: ContactInfosDto;

  @IsEnum(UserRegistrationStep)
  @IsNotEmpty()
  step!: UserRegistrationStep;

  @ValidateNested()
  @Type(() => UserRegistrationConfirmationDto)
  confirmation!: UserRegistrationConfirmationDto;

  @IsMongoIdObject()
  @IsOptional()
  user?: UserId;
}
